import { Box, Divider, Grid, Skeleton, Typography } from "@mui/material";

function FieldSkeleton({ full = false }) {
  return (
    <Box>
      <Skeleton variant="text" width={full ? 132 : 96} height={20} sx={{ mb: 0.75 }} />
      <Skeleton variant="rounded" height={48} sx={{ borderRadius: "6px" }} />
    </Box>
  );
}

function SectionTitleSkeleton({ width = 132 }) {
  return (
    <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, lineHeight: 1.5 }}>
      <Skeleton variant="text" width={width} height={24} />
    </Typography>
  );
}

export default function ProfileFormSkeleton() {
  return (
    <>
      <Grid container columnSpacing={2} rowSpacing={2.25}>
        <Grid item xs={12} md={3} lg={2}>
          <Skeleton
            variant="circular"
            sx={{
              height: { xs: 104, md: 128 },
              mt: { xs: 0, md: 4 },
              mx: { xs: 0, md: "auto" },
              width: { xs: 104, md: 128 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={9} lg={10}>
          <Grid container columnSpacing={2} rowSpacing={2.25}>
            <Grid item xs={12}>
              <FieldSkeleton />
            </Grid>
            <Grid item xs={12}>
              <FieldSkeleton full />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldSkeleton full />
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ borderColor: "#e2e8f0", mt: 1.25 }} />
        </Grid>
      </Grid>

      <Grid container columnSpacing={2} rowSpacing={2.25} sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <SectionTitleSkeleton width={124} />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={6}>
          <FieldSkeleton full />
        </Grid>
        <Grid item xs={12}>
          <FieldSkeleton full />
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ borderColor: "#e2e8f0", mt: 1.25 }} />
        </Grid>
      </Grid>

      <Grid container columnSpacing={2} rowSpacing={2.25} sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <SectionTitleSkeleton width={92} />
        </Grid>
        <Grid item xs={12} md={4}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={8}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={2}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={4}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={4}>
          <FieldSkeleton />
        </Grid>
        <Grid item xs={12} md={2}>
          <FieldSkeleton />
        </Grid>
      </Grid>

      <Box
        sx={{
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          gap: 2,
          justifyContent: "flex-end",
          mt: 3.5,
          pt: 2.5,
        }}
      >
        <Skeleton variant="rounded" width={104} height={40} sx={{ borderRadius: "999px" }} />
        <Skeleton variant="rounded" width={104} height={40} sx={{ borderRadius: "999px" }} />
      </Box>
    </>
  );
}
